export default "__VITE_ASSET__DL_kb7uZ__"